import TipoOrcamento from '../../spa/tipo-orcamento/TipoOrcamento';

export default {
  path: 'tipo-orcamento',
  name: 'tipo-orcamento',
  component: TipoOrcamento,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/tipo-orcamento.js